import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TaskService } from '../../services/task.service';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrl: './slide-toggle.component.scss'
})
export class SlideToggleComponent implements OnInit {
  constructor(private taskService: TaskService) {
  }
  @Input() labelPosition: string;
  @Input() label: string;
  @Input() subtitleLabel: string;
  @Input() showSubtitle: boolean;
  @Output() slideToggleChange = new EventEmitter<boolean>()
  toggleStatus: boolean = false;

  ngOnInit(): void {
    this.taskService.savingNotes.subscribe(() => {
      this.toggleStatus = false;
    })
  }

  onToggleChange(event: MatSlideToggleChange) {
    this.slideToggleChange.emit(event.checked);
  }
}
